import TiptapUnderline from "@tiptap/extension-underline";
import { ActionButton } from "../../components";

export const Underline = TiptapUnderline.extend({
	addOptions() {
		return {
			...this.parent?.(),
			button({ editor, t }) {
				return {
					component: ActionButton,
					componentProps: {
						action: () => editor.commands.toggleUnderline(),
						isActive: () => editor.isActive("underline") || false,
						icon: "Underline",
						shortcutKeys: ["mod", "U"],
						tooltip: t("editor.underline.tooltip")
					}
				};
			}
		};
	}
});
